import { combineReducers } from "redux";

/**
 *  Create a combine reducers
 */
import app from "./app";
import data from "./data";

export default combineReducers({ app, data });
